import {DateTime} from 'luxon';
import getOrdinal from './getOrdinal';

const formatDateFromFirebaseTimestamp = obj => {
  const epochTime = obj.seconds;
  const dateTime = DateTime.fromSeconds(epochTime);
  return `${dateTime.day}${getOrdinal(dateTime.day)} ${dateTime.monthLong} ${dateTime.year}`;
};

export default formatDateFromFirebaseTimestamp;
